/** Labels and defaults shared by the quote screens. */
import { BENZ_F26048_QC_RULES, qcDefaultsForAircraftType, type QcRule } from '@teslyn/domain';
import type { QuoteListRow, TenantDocuments } from './api.ts';

export const QUOTE_STATUS_LABEL: Record<QuoteListRow['status'], string> = {
  draft: 'Draft',
  sent: 'Sent',
  accepted: 'Accepted',
  declined: 'Declined',
  superseded: 'Superseded',
  expired: 'Expired',
};

/** The tenant's QC defaults for every aircraft type (`''` row), else the F26048 values (decision 123). */
export function tenantQcDefaults(docs: TenantDocuments, aircraftType = ''): QcRule[] {
  const typed = docs.qcDefaults.find((d) => d.aircraft_type !== '' && d.aircraft_type === aircraftType);
  const all = docs.qcDefaults.find((d) => d.aircraft_type === '');
  if (typed) return typed.rules;
  return qcDefaultsForAircraftType(all?.rules ?? BENZ_F26048_QC_RULES, aircraftType);
}
